<template>
<v-layout row>
        <v-flex xs12>
            <v-card>
                <v-card-title primary-title class="grey lighten-4">
                    <!-- <v-tooltip top>
                         <v-btn
                            slot="activator"
                            dark
                            @click.stop="helpdialog = true"
                            icon class="mx-0">
                        <v-icon color="red">help</v-icon>
                        </v-btn>
                        <span>Cajas/App</span>
                    </v-tooltip> -->
                    <h3 class="headline mb-0">Cuotas Especiales</h3>

                    <v-spacer></v-spacer>
                        <v-text-field
                            @change="onChange"
                            slot="input"
                            v-model="search"
                            append-icon="search"
                            label="Buscar"
                            single-line
                            hide-details
                        ></v-text-field>
                    <v-spacer></v-spacer>
                    <!-- <v-btn color="primary" dark class="mb-2" @click="addConcepto">Nuevo Concepto</v-btn> -->
                </v-card-title>
                <div>

                  <v-data-table
                    :headers="headers"
                    :items="conceptos"
                    :pagination.sync="pagination"
                    :total-items="total"
                    :rows-per-page-items="rowsPerPageItems"
                    :loading="loading"
                    row
                    wrap
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>{{ props.item.code.toUpperCase() }}</td>
                      <td>{{ props.item.name }}</td>
                      <td>{{ props.item.categoria}}</td>
                      <td>{{ Number(props.item.amount).toLocaleString('de-DE') }}</td>
                      <td class="justify-center layout px-0">

                      <v-tooltip top>
                          <v-btn slot="activator" icon class="mx-0" @click="openModalgenerarFacturasMasivas(props.item)">
                            <v-icon color="info">description</v-icon>
                          </v-btn>
                          <span>Generar Facturas Masivas</span>
                      </v-tooltip>

                      <!-- <v-tooltip top>
                        <v-btn :disabled="props.item.id <= 5" slot="activator" icon class="mx-0" @click="deleteItem(props.item)">
                          <v-icon color="red">
                            delete
                          </v-icon>
                        </v-btn>
                        <span>Eliminar</span>
                      </v-tooltip> -->

                      </td>

                    </template>
                  </v-data-table>
                </div>

            </v-card>
        </v-flex>


  <!-- Inicio de dialogo -->
    <v-dialog
          v-model="helpdialog"
          max-width="600"
        >
          <v-card>
            <v-card-title class="headline">Conceptos</v-card-title>

            <v-card-text>
              Visualización, Creación, Edición y Eliminación de los Conceptos de Servicio.
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="green darken-1"
                flat="flat"
                @click="helpdialog = false"
              >
                Salir
              </v-btn>

            </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fin de dialogo -->

  <!-- Inicio de dialogo -->
    <v-dialog
          v-model="dialogGFactura"
          max-width="600"
        >
          <v-card>
            <v-card-title class="headline">Generar Facturas Masivas</v-card-title>

            <v-card-text>
              Desea Generar Facturas a todos los agremiados por el concepto seleccionado? este proceso no se puede reversar.
            </v-card-text>

            <v-card-actions>

              <v-btn :disabled="loading" color="green darken-1" flat="flat" @click="dialogGFactura = false">
                Salir
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn
                :disabled="loading"
                color="green darken-1"
                flat="flat"
                @click="generarFacturasMasivas"
              >
                Generar
              </v-btn>

            </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fin de dialogo -->


    <v-dialog v-model="loading" hide-overlay persistent width="300">
        <v-card color="primary" dark>
            <v-card-text>
              Porfavor Espere...
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>

    </v-layout>
</template>

<script>
import axios from 'axios'

  export default {
    name: "admin-concepto-view",

    data: () => ({
      dialog: false,
      dialogGFactura: false,
      helpdialog: false,
      loading: false,
      total: 0,
      tipo: '',
      search: '',
      pagination: {},
      item: {},
      headers: [
        { text: 'CODIGO', align: 'left', sortable: false, value: 'code' },
        { text: 'CONCEPTO', align: 'left', sortable: false, value: 'name' },
        { text: 'CATEGORIA', align: 'left', sortable: false, value: 'categoria' },
        { text: 'MONTO', align: 'left', sortable: false, value: 'amount' },
        { text: 'ACCIONES', align: 'center', value: '', sortable: false }
      ],
      rowsPerPageItems: [10, 20, 50, 100],
      conceptos: [],
      editedIndex: -1,
      editedItem: {
        code: '',
        name: '',
        category_id: ''
      },
      defaultItem: {
        code: '',
        name: '',
        category_id: ''
      }
    }),

    watch: {

        pagination() {
            this.getConceptosByPagination();
        }

    },

    methods: {

      openModalgenerarFacturasMasivas(item) {
        this.item = item
        this.dialogGFactura = true
      },

      async generarFacturasMasivas () {
        this.loading = true
        await axios.post(`/api/administration/cuotas-especiales/generacion-masiva`, { concept_cost_id: this.item.id })
          .then(res => {
            this.dialogGFactura = false
            this.loading = false
          })
          .catch(e => {
            console.log(e.response.data)
          })
          .finally(() => this.loading = false);
      },

      addConcepto () {
        this.tipo = "crear"
        this.dialog = true
      },

        async getConceptosByPagination() {
                this.loading = true;
                if (this.search) {
                    await axios.get(`/api/administration/cuotas-especiales-filter?query=${this.search}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                        .then(res => {
                            this.conceptos = res.data.data;
                            this.total = res.data.total;
                        })
                        .finally(() => this.loading = false);
                }
                if (this.pagination.sortBy && !this.search) {
                    const direction = this.pagination.descending ? 'desc' : 'asc';
                    await axios.get(`/api/administration/cuotas-especiales-order?direction=${direction}&sortBy=${this.pagination.sortBy}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                        .then(res => {
                            this.conceptos = res.data.data;
                            this.total = res.data.total;
                        })
                        .finally(() => this.loading = false);
                }
                if(!this.search && !this.pagination.sortBy) {
                  await axios.get(`/api/administration/cuotas-especiales?page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                        .then(res => {
                            this.conceptos = res.data.data;
                            this.total = res.data.total;
                        })
                        .finally(() => this.loading = false);
                }
            },

            onChange () {
                this.getConceptosByPagination();
            },

    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/cobranza/CuotaEspecial.vue